import { selector } from 'recoil';
import { sessionState } from 'store';
import {
  AnalysisApiClient,
  AuthApiClient,
  BackendGatewayCustomersApiClient,
  BackendGatewayManualRecordsApiClient,
  BackendGatewayMetersApiClient,
  BackendGatewayUsersApiClient,
  BuildingFloorplanApiClient,
  BuildingsApiClient,
  HardwaresApiClient,
  LocationsApiClient,
  ManufacturersApiClient,
  MeterModulesApiClient,
  MeterModelsApiClient,
  MetersApiClient,
  ResellersApiClient,
  TemplatesApiClient,
  UsersApiClient,
  CreditInvoicesApiClient,
  EstablishmentsApiClient,
  GatewaysApiClient,
  SupplyPointsApiClient,
} from 'lib/services';
import { HardwarePackagesApiClient } from 'lib/services/hardwarePackagesApi';
import { HardwareVariantsApiClient } from 'lib/services/hardwareVariantsApi';
import { PersonsApiClient } from 'lib/services/personsApi';
import { BackendGatewayFilesApiClient } from 'lib/services/backend-gateway/filesApi';
import { BackendGatewayIntegrationsApiClient } from 'lib/services/backend-gateway/integrationsApi';
import { BackendGatewayRevisionsApiClient } from 'lib/services/backend-gateway/revisionsApi';
import { ThirdPartiesApiClient } from 'lib/services/thirdPartiesApiClient';
import { MeterEventsApiClient } from 'lib/services/meterEventsApi';
import { InventoryMeterReadingGroupsApiClient } from 'lib/services/inventoryMeterReadingGroupsApi';
import { HardwareItemsApiClient } from 'lib/services/hardwareItemsApi';
import type { Services } from './types';
import { DocumentsApiClient } from '../../lib/services/documentsApi';
import { DocumentInvoicesApiClient } from '../../lib/services/documentInvoicesApi';
import { DecoderApiClient } from '../../lib/services/backend-gateway/decoderApi';
import { BackendGatewayDataQualityApiClient } from '../../lib/services/backend-gateway/dataQualityApi';
import { BackendGatewayAdoptionApiClient } from '../../lib/services/backend-gateway/adoptionApi';

export const servicesState = selector<Services>({
  key: 'services',
  get: ({ get }) => {
    const { jwt } = get(sessionState);
    return {
      adminApiClient: new AuthApiClient(jwt),
      backendGatewayCustomersApiClient: new BackendGatewayCustomersApiClient(jwt),
      backendGatewayMetersApiClient: new BackendGatewayMetersApiClient(jwt),
      creditInvoicesApiClient: new CreditInvoicesApiClient(jwt),
      documentsApiClient: new DocumentsApiClient(jwt),
      documentInvoicesApiClient: new DocumentInvoicesApiClient(jwt),
      hardwaresApiClient: new HardwaresApiClient(jwt),
      hardwarePackagesApiClient: new HardwarePackagesApiClient(jwt),
      hardwareVariantsApiClient: new HardwareVariantsApiClient(jwt),
      hardwareItemsApiClient: new HardwareItemsApiClient(jwt),
      inventoryLocationBuildingFloorplansApiClient: new BuildingFloorplanApiClient(jwt),
      inventoryLocationBuildingsApiClient: new BuildingsApiClient(jwt),
      inventoryLocationsApiClient: new LocationsApiClient(jwt),
      inventoryMetersApiClient: new MetersApiClient(jwt),
      inventoryMeterReadingGroupsApiClient: new InventoryMeterReadingGroupsApiClient(jwt),
      manufacturersApiClient: new ManufacturersApiClient(jwt),
      meterModulesApiClient: new MeterModulesApiClient(jwt),
      meterModelsApiClient: new MeterModelsApiClient(jwt),
      meterEventsApiClient: new MeterEventsApiClient(jwt),
      personsApiClient: new PersonsApiClient(jwt),
      resellersApiClient: new ResellersApiClient(jwt),
      templatesApiClient: new TemplatesApiClient(jwt),
      thirdPartiesApiClient: new ThirdPartiesApiClient(jwt),
      usersApiClient: new UsersApiClient(jwt),
      meters: {
        decoderApiClient: new DecoderApiClient(jwt),
      },
      backendGateway: {
        meters: new BackendGatewayMetersApiClient(jwt),
        analysisApiClient: new AnalysisApiClient(jwt),
        establishmentsApiClient: new EstablishmentsApiClient(jwt),
        users: new BackendGatewayUsersApiClient(jwt),
        customersApiClient: new BackendGatewayCustomersApiClient(jwt),
        filesApiClient: new BackendGatewayFilesApiClient(jwt),
        gatewaysApiClient: new GatewaysApiClient(jwt),
        integrationsApiClient: new BackendGatewayIntegrationsApiClient(jwt),
        manualRecordsApiClient: new BackendGatewayManualRecordsApiClient(jwt),
        revisionsApiClient: new BackendGatewayRevisionsApiClient(jwt),
        dataQualityApiClient: new BackendGatewayDataQualityApiClient(jwt),
        supplyPointsApiClient: new SupplyPointsApiClient(jwt),
        adoptionApiClient: new BackendGatewayAdoptionApiClient(jwt),
      },
    };
  },
});
